import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Import configs and util modules
import { FormattedMessage } from '../../../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../../../util/types';
import { types as sdkTypes } from '../../../../util/sdkLoader';

// Import shared components
import { ListingLink } from '../../../../components';

// Import modules from this directory
import css from './EditListingMeasurementPanel.module.css';
import { categoryOptions } from '../../../../config/configListing';
import MeasureMentForm from './MeasureMentForm';

const { Money } = sdkTypes;
export const KEY_MEASUREMENTS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const FOLDED_MEASUREMENTS = ['A', 'B', 'C'];
const getInitialValues = (params, selectedImageData = []) => {
  const { listing } = params;
  const { publicData } = listing?.attributes || {};
  const {
    type,
    category,
    folded_measurement,
    key_measurement,
    subCategory,
    size,
    colour,
    fabrics,
    embroidery,
  } = publicData || {};

  const measurements = selectedImageData?.reduce((acc, item) => {
    const { image, fields } = item;
    fields.forEach(field => {
      acc[`${field}_key_${image}`] = publicData[`${field}_key_${image}`];
    });
    return acc;
  }, {});

  const data = categoryOptions?.find(cat => cat.key === category);
  return {
    ...measurements,
    category: data ? data?.key : null,
    folded_measurement: folded_measurement == 'in' ? true : false,
    key_measurement: key_measurement == 'in' ? true : false,
    size,
  };
};

const EditListingMeasurementPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    marketplaceCurrency,
    listingMinimumPriceSubUnits,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    handleSaveDraft,
    saveDraftInProgress,
    saveDraftError,
    handleBack,
  } = props;

  const { publicData, state, title } = listing?.attributes || {};
  console.log('title', title);
  const { category, subCategory, type, colour } = publicData || {};
  const data = categoryOptions?.find(cat => cat.key === category);
  const subCategories = data?.subCategories || [];
  const subCategoryData = subCategories?.find(item => item.key === subCategory);
  const typeOptions = subCategoryData?.type ? subCategoryData?.type : [];
  const selectedType = typeOptions.find(i => i.key == type);
  const selectedImageData = selectedType?.image;
  const categoryLabel = data?.label;
  const classes = classNames(rootClassName || css.root, className);
  const initialValues = getInitialValues(props, selectedImageData);

  const isPublished = listing?.id && listing?.attributes?.state !== LISTING_STATE_DRAFT;
  const priceCurrencyValid =
    marketplaceCurrency && initialValues.price instanceof Money
      ? initialValues.price.currency === marketplaceCurrency
      : !!marketplaceCurrency;
  const unitType = listing?.attributes?.publicData?.unitType;
  const measurements = (values, savedMeasurements = []) => {
    const data = savedMeasurements?.reduce((acc, item) => {
      const { image, fields } = item;
      fields.forEach(field => {
        acc[`${field}_key_${image}`] = values[`${field}_key_${image}`]
          ? values[`${field}_key_${image}`]
          : null;
      });
      return acc;
    }, {});
    return data;
  };
  const handleSaveListingDraft = values => {
    const { folded_measurement, key_measurement, size } = values;

    // New values for listing attributes
    const updateValues = {
      publicData: {
        ...measurements(values, selectedImageData),
        folded_measurement: 'in',
        key_measurement: 'in',
        size,
      },
    };

    handleSaveDraft(updateValues);
  };
  return (
    <div className={classes}>
      <h2 className={css.listNewItem}>
        <FormattedMessage id="EditListingMeasurementPanel.EditListingMeasurementPanel.listNewItem" />
      </h2>
      <h1 className={css.title}>
        {isPublished ? (
          <FormattedMessage
            id="EditListingMeasurementPanel.title"
            values={{ listingTitle: <ListingLink listing={listing} />, lineBreak: <br /> }}
          />
        ) : (
          <FormattedMessage
            id="EditListingMeasurementPanel.createListingTitle"
            values={{ lineBreak: <br /> }}
          />
        )}
      </h1>
      <MeasureMentForm
        className={css.form}
        initialValues={initialValues}
        onSubmit={values => {
          const { folded_measurement, key_measurement, size } = values;

          // New values for listing attributes
          const updateValues = {
            publicData: {
              ...measurements(values, selectedImageData),
              folded_measurement: 'in',
              //  folded_measurement == true ? 'in' : 'cm',
              key_measurement: 'in',
              size,
            },
          };
          onSubmit(updateValues);
        }}
        marketplaceCurrency={marketplaceCurrency}
        unitType={unitType}
        listingMinimumPriceSubUnits={listingMinimumPriceSubUnits}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        data={data}
        title={title}
        KEY_MEASUREMENTS={KEY_MEASUREMENTS}
        FOLDED_MEASUREMENTS={FOLDED_MEASUREMENTS}
        subCategoryData={subCategoryData}
        categoryLabel={categoryLabel}
        type={type}
        colour={colour}
        handleSaveListingDraft={handleSaveListingDraft}
        saveDraftInProgress={saveDraftInProgress}
        saveDraftError={saveDraftError}
        handleBack={handleBack}
      />
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingMeasurementPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingMeasurementPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingMeasurementPanel;
